import React, { FunctionComponent } from 'react'
import { ReactComponent as TaskEmptyIcon } from '../../../../assets/images/tasks/tasks.svg'
import { GridLayout } from '../../../shared'
import styles from './TaskNotFound.module.scss'

export const TaskNotFound: FunctionComponent = () => {
  return (
    <div className={styles.taskNotFoundContainer}>
      <GridLayout
        alignColumns="center"
        columnsTemplate="auto auto 1fr"
        shouldShrinkOnMobile={false}
        gap="small"
      >
        <div className={styles.taskNotFoundIconContainer}>
          <TaskEmptyIcon />
        </div>
        <div className={styles.taskNotFoundTextContainer}>
          <p>Plus aucune tâche...</p>
        </div>
      </GridLayout>
    </div>
  )
}
